/**
 * Nur interne Pfade der App zulassen (Schutz vor offenen Weiterleitungen).
 * Abgelehnt werden u. a. „//host“, Backslashes („/\host“ wird von Browsern als „//host“ gelesen),
 * Steuer- und Leerzeichen sowie Anführungszeichen.
 */
export function safeInternalPath(p: unknown): string | null {
  if (typeof p !== 'string' || !p.startsWith('/') || p.startsWith('//')) return null;
  // eslint-disable-next-line no-control-regex
  if (/[\\\s<>"'\u0000-\u001f\u007f]/.test(p)) return null;
  return p;
}
